import listReducer from './list'
import addReducer from './add'

export default {
    listReducer,
    addReducer,
};